<template>
  <div class="about-page">
    <div class="page-cover anim" :style="{backgroundImage: `url(${publicPath}frontend-assets/img/cover-contact.jpg)`}" data-effect="fadeIn" data-duration="2s">
    </div>
    <mu-breadcrumbs class="breadcrumbs white anim" data-effect="fadeInUp" data-duration="1s">
      <mu-breadcrumbs-item :to="{ params: { locale }, name: 'home' }">{{$t('nav.home')}}</mu-breadcrumbs-item>
      <mu-breadcrumbs-item disabled>{{$t(`nav.aboutUs`)}}</mu-breadcrumbs-item>
    </mu-breadcrumbs>
    <!-- 关于我们：静态文案，不依赖接口 -->
    <mu-container class="about-us-box">
      <section class="about-us">
        <h4 class="block-title">{{ $t('company.about') }}</h4>
        <p class="desc">{{ $t('company.aboutDesc') }}</p>
      </section>
      <!-- 公司信息：静态内容，不依赖接口 -->
      <section class="company-info">
        <ul>
          <li>
            <span class="label">{{ $t('company.legalName') }}：</span>
            <span class="value">{{ $t('company.name') }}</span>
          </li>
          <li>
            <span class="label">{{ $t('company.creditCode') }}：</span>
            <span class="value">91440300329617110W</span>
          </li>
          <li>
            <span class="label">{{ $t('company.address') }}：</span>
            <span class="value">{{ $t('company.addressValue') }}</span>
          </li>
          <li>
            <span class="label">{{ $t('company.icp') }}：</span>
            <span class="value">粤ICP备15037089号-1</span>
          </li>
          <li>
            <span class="label">{{ $t('company.contact') }}：</span>
            <span class="value">
              {{ $t('contact.tel') }}：0755-82371248-801<br>
              {{ $t('contact.fax') }}：0755-86359374<br>
              {{ $t('contact.hotline') }}：400-873-7518
            </span>
          </li>
        </ul>
      </section>
    </mu-container>
    <mu-container class="contact-box">
      <div class="wrap">
        <div class="swiss">
          <h4>{{$t('contact.swiss')}}</h4>
          <p>
            <i class="iconfont icon-dizhi"></i>
            <span class="label">{{$t('contact.address')}}：</span> <br />
            <span class="value">Rue des Perrieres 8, 2340 Le Noirmont I SWITZERLAND</span>
          </p>
          <p>
            <i class="iconfont icon-tel"></i>
            <span class="label">{{$t('contact.tel')}}：</span> <br />
            <span class="value">+41  (0)329670670</span>
          </p>
          <p>
            <i class="iconfont icon-chuanzhen"></i>
            <span class="label">{{$t('contact.fax')}}：</span> <br />
            <span class="value">+41  (0)329670670</span>
          </p>
          <p>
            <i class="iconfont icon-email"></i>
            <span class="label">Email：</span> <br />
            <span class="value">contact@codex-watches.ch</span>
          </p>
        </div>
        <div class="china">
          <h4>{{$t('contact.shenzhen')}}</h4>
          <p>
            <i class="iconfont icon-dizhi"></i>
            <span class="label">{{$t('contact.address')}}：</span> <br />
            <span class="value">{{ $t('contact.companyAddress') }}</span>
          </p>
          <p>
            <i class="iconfont icon-tel"></i>
            <span class="label">{{$t('contact.tel')}}：</span> <br />
            <span class="value">0755-82371248-801</span>
          </p>
          <p>
            <i class="iconfont icon-chuanzhen"></i>
            <span class="label">{{$t('contact.fax')}}：</span> <br />
            <span class="value">0755-86359374</span>
          </p>
          <p>
            <i class="iconfont icon-kefu"></i>
            <span class="label">{{$t('contact.hotline')}}：</span> <br />
            <span class="value">+ 4008737518</span>
          </p>
        </div>
      </div>
      <div class="img-box">
        <img :src="`${publicPath}frontend-assets/img/contact-1.png`" alt="">
      </div>
    </mu-container>
  </div>
</template>

<script>
import animateEle from '@/simple.animate';

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  // 切换语言时是同路由「组件复用」，updated() 不保证再次触发，
  // 会把 loading 进度留在 40 收不了尾；统一用 beforeRouteUpdate 上报 100
  beforeRouteUpdate(to, from, next) {
    next();
    this.$store.commit('toggleLoadingScene', 100);
    this.$nextTick(() => {
      animateEle(0);
    });
  },
  mounted() {
    this.$store.commit('toggleLoadingScene', 100);
    this.$nextTick(() => {
      animateEle(0);
    });
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
@import '../styles/vars.less';

.page-cover {
  width: 100%;
  height: 0;
  padding-top: 42.71%;
  background-color: #000;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.breadcrumbs {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.sm, .xs {
  .breadcrumbs {
    padding-top: 100px;
  }
}

.container {
  .router-tabs {
    max-width: 50%;
  }
  @media (min-width: 1200px) {
    max-width: 996px;
  }

  @media (min-width: 1700px) {
    max-width: 1500px;
  }
}

.router-tabs {
  display: flex;
  justify-content: space-between;
  padding-top: 37px;
  padding-bottom: 33px;
  margin-left: auto;
  margin-right: auto;

  .link {
    display: block;
    font-size: 18px;
    padding: 12px 23px;
    color: #000;
    text-decoration: none;
    border-bottom: 1px solid #fff;

    &.active {
      border-color: #000;
    }
  }
}


.about-us-box {
  text-align: left;
  color: #231815;
  padding-top: 48px;

  .block-title {
    position: relative;
    margin: 0;
    padding-bottom: 14px;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: #231815;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 53px;
      height: 1px;
      background-color: @keyColor;
    }
  }

  .about-us {
    .desc {
      margin: 24px 0 0;
      font-size: 15px;
      line-height: 1.9em;
      color: #57585a;
      text-align: justify;
    }
  }

  .company-info {
    margin-top: 40px;

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    li {
      display: flex;
      align-items: flex-start;
      padding: 14px 0;
      font-size: 15px;
      line-height: 1.75em;
      border-bottom: 1px dashed #e9ddcd;

      &:last-child {
        border-bottom: 0;
      }
    }

    .label {
      flex: 0 0 250px;
      box-sizing: border-box;
      padding-right: 16px;
      font-weight: 500;
      color: #231815;

      &::before {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        margin-right: 10px;
        vertical-align: middle;
        background-color: @keyColor;
        transform: rotate(45deg);
      }
    }

    .value {
      flex: 1 1 auto;
      color: #57585a;
      word-break: break-word;
    }
  }
}

.contact-box {
  text-align: left;
  color: #231815;
  line-height: 1.75em;
  padding-top: 30px;
  padding-bottom: 48px;

  .wrap {
    display: flex;

  }

  .img-box {
    margin-top: 5%;
    width: 100%;
    overflow: hidden;

    img {
      display: block;
      width: 100%;
      transform: scale(1);
      transition: all 0.5s;

      &:hover {
      transform: scale(1.1);
      }
    }
  }
  .swiss {
    flex: 1;
    box-sizing: border-box;
    padding-right: 24px;
  }
  .china {
    flex: 1;
    box-sizing: border-box;
    padding-left: 21px;
    border-left: 1px solid #ccc;
  }

  h4 {
    font-size: 24px;
    font-weight: 500;
    clear: both;
  }

  p {
    clear: both;
    margin-top: 30px;

    .iconfont {
      font-size: 50px;
      float: left;
      vertical-align: top;
      margin: 12px 7px 12px 0;
    }

    .value {
      font-size: 15px;
    }
  }
}

.md {
  .router-tabs {
    width: 100%;
    padding-top: 18px;
    padding-bottom: 15px;

    .link {
      font-size: 16px;
      padding: 6px 12px;
    }
  }

  .contact-box {
      width: 100%;
      padding-top: 14px;
      padding-bottom: 24px;
      line-height: 1.6em;

      .img {
        margin-top: 30px;
      }

      .swiss {
        padding-right: 0;
      }

      h4 {
        font-size: 18px;
      }

      p {
        margin-top: 15px;

        .iconfont {
          font-size: 24px;
          margin: 13px 10px 10px 0;
        }

        .value {
          font-size: 16px;
        }
      }
  }

  .about-us-box {
    padding-top: 34px;

    .company-info {
      margin-top: 34px;

      li {
        font-size: 14px;
      }

      .label {
        flex-basis: 230px;
      }
    }
  }
}

.sm, .xs {
  .router-tabs {
    width: 100%;
    padding-top: 18px;
    padding-bottom: 15px;

    .link {
      font-size: 16px;
      padding: 8px 15px;
    }
  }

  .contact-box {
      width: 100%;
      padding-top: 14px;
      padding-bottom: 24px;
      line-height: 1.6em;

      .img {
        margin-top: 30px;
      }

      .wrap {
        flex-direction: column;
      }

      .swiss {
        padding-right: 0;
      }

      .china {
        padding-left: 0;
        border-left: 0 solid #ccc;
        border-top: 2px solid #ccc;
        padding-top: 15px;
        margin-top: 15px;
      }

      h4 {
        font-size: 18px;
      }

      p {
        margin-top: 15px;

        .iconfont {
          font-size: 26px;
          margin: 10px 5px 10px 0;
        }

        .value {
          font-size: 16px;
        }
      }
  }

  .about-us-box {
    padding-top: 22px;

    .block-title {
      font-size: 18px;
      padding-bottom: 10px;

      &::after {
        width: 38px;
      }
    }

    .about-us {
      .desc {
        margin-top: 16px;
        font-size: 13px;
        line-height: 1.75em;
      }
    }

    .company-info {
      margin-top: 26px;

      li {
        flex-direction: column;
        padding: 10px 0;
        font-size: 13px;
      }

      .label {
        flex: none;
        padding-right: 0;
      }
    }
  }
}
</style>
